import { manufacturingPartNumberStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { css } from "styled-components";

styles.labelText = {
    ...styles.labelText,
    css: css`
        margin: 0 8px 0 0;
    `,
};
